module.exports=function(scope){ return `// Make sure the FaceTec SDK is initialized before launching the User Session
if([Zoom.sdk getStatus] == ZoomSDKStatusInitialized) {

    // Core function calls that create and launch the FaceTec Interface
    UIViewController *sessionVC = [Zoom.sdk createSessionVCWithDelegate:self];

    // When presenting the FaceTec Interface over your own application, you can keep your application showing in the background by using this presentation style
    [sessionVC setModalPresentationStyle:UIModalPresentationOverCurrentContext];

    // Present FaceTec SDK view controller and capture a session
    [self presentViewController:sessionVC animated:true completion:nil];
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/quickstart/ios/02-start-enrollment.m.tpl